import React from 'react';
import { Select, DatePicker, Button } from 'antd';
import { ArrowLeft, ChartColumn } from 'lucide-react';
import dayjs from 'dayjs';
import { PageHeader, FilterBar, FilterField } from '../../../common';
import { t } from '../../../../company/labels';

const { RangePicker } = DatePicker;

function AnalyticsHeader({
    period,
    limit,
    channel,
    tagId,
    startDate,
    endDate,
    tags,
    changePeriod,
    changeLimit,
    changeChannel,
    changeTag,
    changeDateRange,
    goBack,
    loading
}) {
    const periodOptions = [
        { value: 'day', label: 'Hoy' },
        { value: 'week', label: 'Esta Semana' },
        { value: 'month', label: 'Este Mes' }
    ];

    const limitOptions = [
        { value: 5, label: 'Top 5' },
        { value: 10, label: 'Top 10' },
        { value: 15, label: 'Top 15' },
        { value: 20, label: 'Top 20' },
        { value: 50, label: 'Top 50' },
        { value: 100, label: 'Top 100' },
        { value: 999, label: `Todos los ${t('promotores')}` }
    ];

    const channelOptions = [
        { value: 'all', label: 'Todos los Canales' },
        { value: 'moderno', label: 'Moderno' },
        { value: 'tradicional', label: 'Tradicional' }
    ];

    const tagOptions = [
        { value: 'all', label: 'Todas las Etiquetas' },
        ...tags.map((tag) => ({
            value: tag._id,
            label: tag.name
        }))
    ];

    const handlePeriodChange = (value) => {
        console.log('🎛️ Period change triggered:', value);
        // Clear custom dates when period changes
        changeDateRange(null, null);
        changePeriod(value);
    };

    const handleLimitChange = (value) => {
        console.log('🎛️ Limit change triggered:', value);
        changeLimit(value);
    };

    const handleChannelChange = (value) => {
        console.log('🎛️ Channel change triggered:', value);
        changeChannel(value);
    };

    const handleTagChange = (value) => {
        console.log('🎛️ Tag change triggered:', value);
        changeTag(value);
    };

    const handleDateRangeChange = (dates) => {
        if (dates && dates.length === 2) {
            const start = dates[0].format('YYYY-MM-DD');
            const end = dates[1].format('YYYY-MM-DD');
            console.log('🎛️ Date range change triggered:', { start, end });
            changeDateRange(start, end);
        } else {
            // Dates cleared
            changeDateRange(null, null);
        }
    };

    return (
        <div>
            <PageHeader
                icon={<ChartColumn />}
                title={`Analíticas de ${t('promotores')}`}
                description={`Rendimiento y estadísticas de ${t('promotoresLower')}`}
                actions={
                    <Button icon={<ArrowLeft />} onClick={goBack} disabled={loading}>
                        Volver a {t('promotores')}
                    </Button>
                }
            />

            <FilterBar className="!mb-0">
                <FilterField label="Período" width={160}>
                    <Select
                        value={period}
                        options={periodOptions}
                        onChange={handlePeriodChange}
                        className="w-full"
                        disabled={loading || (startDate && endDate)}
                    />
                </FilterField>

                <FilterField label="Rango Personalizado" width={280}>
                    <RangePicker
                        value={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null}
                        onChange={handleDateRangeChange}
                        format="DD/MM/YYYY"
                        disabled={loading}
                        placeholder={['Fecha Inicio', 'Fecha Fin']}
                        className="w-full"
                    />
                </FilterField>

                <FilterField label="Mostrar" width={180}>
                    <Select value={limit} options={limitOptions} onChange={handleLimitChange} className="w-full" disabled={loading} />
                </FilterField>

                <FilterField label="Canal" width={180}>
                    <Select value={channel} options={channelOptions} onChange={handleChannelChange} className="w-full" disabled={loading} />
                </FilterField>

                <FilterField label="Etiqueta" width={200}>
                    <Select value={tagId} options={tagOptions} onChange={handleTagChange} className="w-full" disabled={loading} />
                </FilterField>
            </FilterBar>
        </div>
    );
}

export default AnalyticsHeader;
